/* Copyright (c) 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useEffect } from "react";
import { useCustomer } from "~/context";
import { ROUTES } from "~/routing/routes";
import { useGetResourceGroups } from "~/views/resourceGroups/hooks";
import { DataBox } from "../DataBox/DataBox";

export function ResourceGroupsCard() {
  const { customer } = useCustomer();

  const { count, refetch } = useGetResourceGroups({
    page: "1",
    limit: "1",
    basic: true,
  });

  useEffect(() => {
    refetch();
  }, [customer, refetch]);

  return (
    <DataBox
      icon="flowchart"
      title="Resource Groups"
      value={count}
      iconLink={ROUTES.resourceGroups.index}
    />
  );
}
